import { skipToken } from '@reduxjs/toolkit/query';
import {
    EnrollmentStatusIndicator,
    OnboardingStatusIndicator,
    ReferralStatusIndicator,
} from '@strata/react-status-indicators';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PropTypes from 'prop-types';

import { PLATFORM_ELIGIBILITY_PENDING } from 'services/memberEligibilityStatus';
import { useGetOnboardingStatusQuery } from 'store/api/onboardingApi';

export const ReferralAndOnboardingStatusIndicator = ({
    referralStatus,
    enrollmentStatus = undefined,
    onboardingStatus = undefined,
    referralId = undefined,
    skipFetch = false,
}) => {
    const { agoraEnhancedEligibility } = useFlags();

    const canShowEnrollmentMonitoring =
        agoraEnhancedEligibility && referralStatus !== ReferralStatusIndicator.Statuses.EXPIRED;

    const canShowOnboardingStatus = referralStatus === ReferralStatusIndicator.Statuses.PHARM;
    const canFetchOnboardingStatus = !onboardingStatus && !skipFetch;

    const { data: onboardingStatusFromAPI } = useGetOnboardingStatusQuery(
        canShowOnboardingStatus && canFetchOnboardingStatus ? referralId : skipToken,
    );

    const onboardingStatusToDisplay = onboardingStatus ?? onboardingStatusFromAPI;
    const isEnrollmentMonitoring = enrollmentStatus === PLATFORM_ELIGIBILITY_PENDING;

    if (canShowEnrollmentMonitoring && isEnrollmentMonitoring) {
        return <EnrollmentStatusIndicator status={EnrollmentStatusIndicator.Statuses.PENDING} />;
    }

    if (canShowOnboardingStatus && onboardingStatusToDisplay) {
        return <OnboardingStatusIndicator status={onboardingStatusToDisplay} />;
    }

    return <ReferralStatusIndicator status={referralStatus} />;
};

ReferralAndOnboardingStatusIndicator.propTypes = {
    enrollmentStatus: PropTypes.string,
    onboardingStatus: PropTypes.oneOf(Object.keys(OnboardingStatusIndicator.Statuses)),
    referralId: PropTypes.string,
    referralStatus: PropTypes.oneOf(Object.keys(ReferralStatusIndicator.Statuses)).isRequired,
    skipFetch: PropTypes.bool,
};
